// extracted by mini-css-extract-plugin
export default {"content":"input_content__34WpC","input":"input_input__bAnmr"};